export const shadows = {
  xs: "0px 3px 5px -1px rgba(39, 31, 77, 0.06)",
  large:
    "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
};
